export default __webpack_public_path__ + "57d5b36a68ee83938ffe9cf3a99bba7b.png";